import { sanitizeValues } from '@intelligence/v3/utils/common';

import type { IGameSelectFilterValue } from './types';

const getNormalizedKeywords = (keywords: unknown): string => {
  return typeof keywords === 'string' ? keywords.trim() : '';
};

export const getGameSelectValue = (value: unknown): IGameSelectFilterValue => {
  const gameValue = value as IGameSelectFilterValue | undefined;
  const normalizedValue = sanitizeValues(Array.isArray(gameValue?.value) ? gameValue?.value : []);
  const normalizedKeywords = getNormalizedKeywords(gameValue?.keywords);
  const isSearchAll = gameValue?.isSearchAll === true && normalizedKeywords !== '' && normalizedValue.length === 0;

  return {
    value: normalizedValue,
    keywords: isSearchAll ? normalizedKeywords : '',
    isSearchAll,
    checkedList: Array.isArray(gameValue?.checkedList) ? gameValue?.checkedList : [],
  };
};
